import { ROUTE_INVESTING_IDEA_MARKET_INDUSTRY } from '@/constants/routes';
import type { GridViewOptions } from '../../../pages/CompanyReport/constants/constants';

export default function useInvestingIdea(
  ideaName: string,
  gridView: GridViewOptions,
  market: string,
  industry: string
) {
  if (market === '' || industry === '') return undefined;

  return {
    results: 0,
    linkToInvestingIdea: {
      type: ROUTE_INVESTING_IDEA_MARKET_INDUSTRY,
      payload: {
        id: gridView,
        name: ideaName,
        market: market.toLowerCase(),
        industry,
      },
    },
  };
}
